export default __webpack_public_path__ + "static/media/thumbs-up.3baf6df8.png";